import * as React from "react";
const SvgFiRrEquality = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-equality_svg__a)">
      <path
        fill="#062147"
        d="m23.944 12.669-3.031-8.66a3 3 0 0 0-2.832-2.01H13V1a1 1 0 1 0-2 0v1H5.919a3 3 0 0 0-2.832 2.009l-3.031 8.66c-.037.106-.056.632-.056.632 0 2.506 1.871 4.567 4.26 4.692a4.46 4.46 0 0 0 3.338-1.229A4.52 4.52 0 0 0 9 13.5s-.021-.732-.061-.842l-3.145-8.65Q5.856 4 5.919 4H11v18H5a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2h-6V4h5.081q.063 0 .125.008l-3.146 8.65c-.04.109-.061.842-.061.842a4.52 4.52 0 0 0 1.402 3.264c.845.802 1.828 1.229 3.339 1.229 2.391 0 4.259-2.186 4.259-4.692 0 0-.018-.526-.055-.632m-19.58 3.328C3.283 15.94 2.378 15.095 2.098 14H6.95c-.1.499-.35.954-.729 1.313a2.49 2.49 0 0 1-1.856.683zM6.572 12H2.409l2.042-5.833zm12.977-5.833L21.591 12h-4.163zm.088 9.83a2.5 2.5 0 0 1-1.857-.683 2.48 2.48 0 0 1-.729-1.313h4.852c-.28 1.094-1.184 1.94-2.265 1.997z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-equality_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrEquality;
